import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

Vue.config.devtools = true;

import uxModule from "./Modules/uxModule";
import sharedModule from "./Modules/sharedModule";
import securityModule from "./Modules/securityModule";
import templatesModule from "./Modules/templatesModule";
import optionsModule from "./Modules/optionsModule";
import notesModule from "./Modules/notesModule";
import reportsModule from "./Modules/reportsModule";
import filesModule from "./Modules/filesModule";
const state = {};

const mutations = {};

const actions = {};

const store = new Vuex.Store({
  modules: {
    uxModule: uxModule,
    sharedModule: sharedModule,
    securityModule: securityModule,
    templatesModule: templatesModule,
    optionsModule: optionsModule,
    notesModule: notesModule,
    reportsModule: reportsModule,
    filesModule: filesModule,
  },

  state,
  mutations,
  actions,
});

export default store;
